import React from "react";
import ReportPage from "./views/ReportPage";
import { ReportContextProvider } from "./ReportView";

const ReportView = () => {
  return (
    <ReportContextProvider>
      <ReportPage />
    </ReportContextProvider>
  );
};
export default ReportView;
